import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
import ElementUI from 'element-ui'
import './assets/scss/modul.scss'
import 'element-ui/lib/theme-chalk/index.css'
// import {Message} from 'element-ui'
// Vue.prototype.$message = Message;
import local from './api/local'
import util from './api/util'; //引入公用js
import config from './api/config.js';
import moment from 'moment'
let api = Object.assign({}, local);
Vue.prototype.$moment = moment;
Vue.prototype.$config = config
Vue.prototype.util = util; //将公用js ：util指向vue原型链
Vue.use(ElementUI)
Vue.prototype.$util = util; //将公用js ：util指向vue原型链
// import scroll from 'vue-seamless-scroll'
// Vue.use(scroll)

// Vue.prototype.$axios = api; //将公用js ：util指向vue原型链
// import {Message} from 'element-ui'
// Vue.prototype.$message = Message;
// import loading from './views/components/loading/loading.js' // 引入loading
// Vue.use(loading) // 全局使用loading

// import imgshows from './views/components/imgshow/index' // 引入loading
// Vue.use(imgshows) // 全局使用loading
import './assets/font/font.scss';
import $api from './api/api'
Vue.prototype.$api = $api
import * as echarts from 'echarts';
import {
	flexible
} from '@/utils/flexible.js';
flexible(window, document);

//vue-iclient3d-webgl组件库
import  '@supermap/vue-iclient3d-webgl/dist/styles/vue-iclient3d-webgl.min.css';
import VueiClient from '@supermap/vue-iclient3d-webgl';
Vue.use(VueiClient);


Vue.prototype.$echarts = echarts;
Vue.use(ElementUI)
// 路由跳转前判断登录状态
router.beforeEach((to, from, next) => {
	// console.log(to);
	if (to.name == null) {
		next({
			path: '/',
			// query: {
			//   redirect: to.fullPath
			// } // 将跳转的路由path作为参数，登录成功后跳转到该路由
		})
	} else {
		// console.log(11111);
		if (to.matched.some(record => {
			// console.log(record);
				record.meta.requireAuth
			})) { // 判断该路由是否需要登录权限
			console.log(22222);
			if (sessionStorage.getItem("token") && sessionStorage.getItem(
					"userInfo")) { // 判断当前的token是否存在 ； 登录存入的token
				next();
			} else {
				next({
					path: '/login',
					// query: {
					//   redirect: to.fullPath
					// } // 将跳转的路由path作为参数，登录成功后跳转到该路由
				})
			}
		} else {
			next();
		}
	}

});
/* 视频监控插件 */
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import 'videojs-flash'
import 'videojs-contrib-hls/dist/videojs-contrib-hls'
Vue.use(VueVideoPlayer)
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
